import { search_asp } from "../util";

export function translateWrapAnnotationBy(tech, args, line, parsed, source, mapping, processed, config) {
  // do(wrap_annotation_by,A,60).
  let rules = [];
  let anno = source.annotation?.items?.[mapping[args[0]].annotation];
  let ratio = parseInt(args[1]) / 100;
  let rule = {
    category: "recommender",
    description: `${tech.startsWith('wrap') ? "Wrap" : "Unwrap"} annotation ${anno.name || ""}`,
    specifier: {
      role: "annotation"
    },
    action: "modify",
    option: {
      width: { prod: ratio }
    }
  };
  if (anno.name) rule.specifier.id = anno.name;
  else if (anno.text) {
    rule.specifier.text = {
      startsWith: (anno.text.constructor.name === "Array" ? anno.text[0].text : anno.text)
    };
  }
  else rule.specifier.index = anno.name;
  rules.push(rule);
  return rules;
}

export function translateRemoveAnnotation(tech, args, line, parsed, source, mapping, processed, config) {
  // do(remove_annotation,A).
  let rules = [];
  let anno = source.annotation?.items?.[mapping[args[0]].annotation];
  let rule = {
    category: "recommender",
    description: `Remove annotations ${anno.name || ""}`,
    specifier: {
      role: "annotation"
    },
    action: "remove"
  };
  if (anno.name) rule.specifier.id = anno.name;
  else if (anno.text) {
    rule.specifier.text = {
      startsWith: (anno.text.constructor.name === "Array" ? anno.text[0].text : anno.text)
    };
  }
  else rule.specifier.index = parseInt(mapping[args[0]].annotation);
  rules.push(rule);
  return rules;
}

export function translateExternalizeAnnotation(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let anno = source.annotation?.items?.[mapping[args[0]].annotation];
  let rule = {
    category: "recommender",
    description: `Externalize annotation ${anno.name || ""}`,
    specifier: {
      role: "annotation"
    },
    action: "modify",
    option: {
      external: true,
      textAlign: "left"
    }
  };
  if (anno.name) rule.specifier.id = anno.name;
  else if (anno.text) {
    rule.specifier.text = {
      startsWith: (anno.text.constructor.name === "Array" ? anno.text[0].text : anno.text)
    };
  }
  else rule.specifier.index = parseInt(mapping[args[0]].annotation);
  let p;
  if ((p = search_asp(parsed, "do(number_annotation_adj," + args[0] + ")")?.[0], p)) {
    rule.option.numbering = true;
    // 0,0 to signal the originating position;
    rule.option.dx = 0;
    rule.option.dy = 0;
    rule.option.x = null;
    rule.option.y = null;
    rule.option.orient = "middle-center";
    rule.option.anchor = "center";
    rule.option.tick = null;
  }
  rules.push(rule);
  return rules;
}

export function translateExternalizeDataAnnotation(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let with_numbering = (args[0] === "with_numbering");
  let annotations = source.annotation?.items;
  annotations?.forEach((anno, ni) => {
    if (anno.anchor?.dataItem === undefined) return;
    let rule = {
      category: "recommender",
      description: `Externalize annotation ${anno.name || ni}${with_numbering ? " with numbering" : ""}`,
      specifier: {
        role: "annotation"
      },
      action: "modify",
      option: {
        external: true,
        textAlign: "left"
      }
    };
    if (anno.name) rule.specifier.id = anno.name;
    else if (anno.text) {
      rule.specifier.text = {
        startsWith: (anno.text.constructor.name === "Array" ? anno.text[0].text : anno.text)
      };
    }
    else rule.specifier.index = ni;
    if (with_numbering) {
      rule.option.numbering = true;
    }
    rules.push(rule);
  });
  return rules;
}

export function translateNumberAnnotation(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let anno = source.annotation?.items?.[mapping[args[0]].annotation];
  let rule = {
    category: "recommender",
    description: `Number annotation ${anno.name || ""}`,
    specifier: {
      role: "annotation"
    },
    action: "modify",
    option: {
      numbering: true,
      dx: 0,
      dy: 0,
      x: null,
      y: null,
      orient: "middle-center",
      anchor: "center",
      tick: null
    }
  };
  if (anno.name) rule.specifier.id = anno.name;
  else if (anno.text) {
    rule.specifier.text = {
      startsWith: (anno.text.constructor.name === "Array" ? anno.text[0].text : anno.text)
    };
  }
  else rule.specifier.index = parseInt(mapping[args[0]].annotation);
  rules.push(rule);
  return rules;
}

export function translateInternalizeAnnotation(tech, args, line, parsed, source, mapping, processed, config) {
  // do(internalize_annotation,A,non_data)
  let rules = [];
  let anno = source.annotation?.items?.[mapping[args[0]].annotation];
  let rule = {
    category: "recommender",
    description: `Internalize annotation ${anno.name || ""}`,
    specifier: {
      role: "annotation"
    },
    action: "modify",
    option: {
      external: false,
    }
  };
  if (anno.visibility?.externalize?.numbering) {
    rule.option.numbering = false
  }
  if (args[1] === "non_data") {
    rule.option.x = 0;
    rule.option.y = 0;
  } else if (args[1] === "data") {
    rule.option.dx = 0;
    rule.option.dy = 0;
    rule.option.anchor = "start";
  }
  if (anno.name) rule.specifier.id = anno.name;
  else if (anno.text) {
    rule.specifier.text = {
      startsWith: (anno.text.constructor.name === "Array" ? anno.text[0].text : anno.text)
    };
  }
  else rule.specifier.index = parseInt(mapping[args[0]].annotation);
  rules.push(rule);
  return rules;
}

export function translateConvertAnnotation2Title(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let anno = source.annotation?.items?.[mapping[args[0]].annotation];
  let rule = {
    category: "recommender",
    description: `Convert annotation ${anno.name || ""} to a title`,
    specifier: {
      role: "annotation"
    },
    action: "replace",
    option: {
      to: {
        role: "title",
        width: null
      }
    }
  };
  if (anno.name) rule.specifier.id = anno.name;
  else if (anno.text) {
    rule.specifier.text = {
      startsWith: (anno.text.constructor.name === "Array" ? anno.text[0].text : anno.text)
    };
  }
  else rule.specifier.index = parseInt(mapping[args[0]].annotation);
  rules.push(rule);
  return rules;
}
